// extracted by mini-css-extract-plugin
module.exports = {"error":"form_error__1qHcK","button":"form_button__2Yy4i"};